import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dear tech companies, this is not how you hire engineers",
  "description": "",
  "published": "2015-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/dear-tech-companies-this-is-not-how-you-hire-engineers/swizec/6643"],
  "categories": "Business, Software engineer, Software engineering, Startups",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Need girl. 170cm, blonde, 34D.`}</p>
      <p parentName="blockquote">{`Must love discussing astrophysics, philosophy, and mobile startups.`}</p>
      <p parentName="blockquote">{`Opinions on node.js vs. io.js a plus.`}</p>
      <p parentName="blockquote">{`4 year degree or higher.`}</p>
      <p parentName="blockquote">{`Must enjoy fast cars, watching Netflix, and should understand why sprinklers have to be off at 3:32am every third Tuesday of the month.`}</p>
      <p parentName="blockquote">{`Dr. Who appreciation a plus. Will get free dinners, walks on the beach, and skydiving lessons in return.`}</p>
      <p parentName="blockquote">{`Subsidised travel when appropriate.`}</p>
    </blockquote>
    <p>{`Ridiculous, right?`}</p>
    <p>{`And yet, that's what a lot job ads for software engineers look like. The better ones will turn it around and take the `}<em parentName="p">{`We offer more than we take!`}</em>{` approach.`}</p>
    <p>{`They highlight the perks and attach a strong brand. Deep down, they're the same.`}</p>
    <p>{`The more proactive companies hire legions of recruiters to send generic emails to everyone with a pulse. Some better some worse.`}</p>
    <p>{`But here's the thing - software engineering jobs are a total seller's market right now.`}</p>
    <p>{`Every engineer you'd want to hire has already got a job. Or their own company. Or they're still in school.`}</p>
    <p>{`You might get lucky with those still in school. They're juniors and don't know much about the industry. But you will scare them away with that list of requirements. And you'd have to train them anyway.`}</p>
    <p>{`Those with a company ... well you can get those. But only when their company isn't doing well. Or has just folded. You have to get lucky to catch them on a downturn - when they're disheartened.`}</p>
    <p>{`But if they've got a VC funded company, you will have to acquihire. Those are expensive.`}</p>
    <p>{`So you're left with engineers who currently have a job.`}</p>
    <p>{`Those fall into two categories. Employed and happy, and employed and unhappy.`}</p>
    <p>{`You're going to be hard pressed to convince somebody who's already happy. Changing one's entire work environment is stressful so people avoid it. And they will have little job satisfaction before they fully grok your codebase.`}</p>
    <p>{`Your offer will have to be absolutely `}<em parentName="p">{`stellar`}</em>{`.`}</p>
    <p>{`The kind of offer I'm talking about usually isn't.`}</p>
    <p>{`Now, there's the engineers who are unhappy in their current job. These will be easier to convince, but it's unlikely they're going to see your ad. And even then, they are still coming from a position of strength. Disregarding you doesn't cost them a thing.`}</p>
    <p>{`The upside will still have to be pretty good.`}</p>
    <p>{`What I wonder is, `}<em parentName="p">{`why`}</em>{` do you look for engineers like this? By scaring away the only people who might sign up on their own?`}</p>
    <p>{`According to a measure I've heard once (probably depends on many factors), a new full-time engineer adds some $1,000,000 to your company's sell value. They're going to cost you some $300,000 over the two or three years they stay with you, and if all goes well, are going to `}<em parentName="p">{`enable`}</em>{` your revenue production.`}</p>
    <p>{`A few million for sure.`}</p>
    <p>{`As a business person, would you look for million dollar clients with a generic `}<em parentName="p">{`"Have business. Need `}{`\\`}{`\\`}{`\\$1MM in sales. Please apply"`}</em>{` ad?`}</p>
    <p>{`Of course you wouldn't. You'd network like mad, ask everyone for leads, take prospective leads to fancy dinners, write personalised proposals, buy expensive gifts. Etc.`}</p>
    <p>{`Why don't you approach engineers the same way?`}</p>
    <p>{`I promise we'll take you seriously if you feed us and spend an hour explaining how we can help.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      